import CancelItemRuleRequest from './cancel-item-rule.request';

export default class CancelContractRequest {
  contractId: string;

  observation: string;

  rules?: CancelItemRuleRequest[] = [];

  competence: string;

  constructor(obj: any = {}) {
    this.contractId = obj.contractId || '';
    this.observation = obj.observation || '';
    this.competence = obj.competence || '';
  }

  public static of(obj: any = {}): CancelContractRequest {
    return new CancelContractRequest(obj || {});
  }

  public static ofList(obj: any[]): CancelContractRequest[] {
    return obj.map(this.of);
  }
}
